module.exports = __webpack_public_path__ + "img/move25.5a5c70b0.jpg";